
  export default {
    props: {
      image: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      }
    }
  };
